export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10332.515a5029.jpg";